export default {
  // Snackbar
  linkCopiedToClipboard: '¡Enlace copiado al portapapeles!',

  // KPI selector
  kpiLabel: 'KPI',

  // Share plan tooltip and dialog
  sharePlan: 'Compartir Plan',
  shareDialogTitle: 'Compartir "{name}"',
  sharingDisabled: 'Compartir deshabilitado',
  sharingEnabled: 'Compartir habilitado',
  creatingLink: 'Creando Enlace...',
  done: 'Listo',

  // Metrics
  budgetLabel: 'Presupuesto ({unit})',
  predictedLabel: '{kpiName} Proyectadas ({unit})',
  restrictions: 'Restricciones',

  // Restriction types
  restrictionUnrestricted: 'Sin restricción',
  restrictionMoreThan: 'Más de',
  restrictionLessThan: 'Menos de',
  restrictionBetween: 'Entre',
  restrictionExactly: 'Exactamente',
  restrictionSpendIn: 'Gastar en',
  restrictionAnd: 'y',

  // Tabs
  tabFullPeriodSummary: 'Resumen del Período Completo',
  tabMonthlyDetailView: 'Vista Detallada Mensual',
  tabWeeklyDetailView: 'Vista Detallada Semanal',
  tabTouchpoints: 'Puntos de Contacto',
  tabSegments: 'Segmentos',
  tabAdmin: 'Admin',

  // Chart titles
  salesDecompositionTitle: 'Descomposición de {kpiName} ({unit})',
  mediaKpiByChannelTitle: '{kpiName} de Medios por Canal ({unit})',
  mediaSpendCalendarTitle: 'Calendario de Inversión en Medios ({unit})',
  mediaMixTitle: 'Mix de Medios ({unit})',

  // Admin tab
  rawOutputLabel: 'Salida RAW',
  injectChanges: 'Inyectar cambios',

  // Loading
  loading: 'Cargando...'
}
